'use client'

import { Box, Card, Skeleton } from '@chakra-ui/react'

export default function SkeletonProductCard() {
  return (
    <Card.Root
      rounded={16}
      variant='subtle'
      bg={{ base: 'background', lg: 'background.card' }}
      overflow='hidden'
    >
      {/* Image / Header */}
      <Card.Header px={{ base: 2, lg: 4 }} pt={{ base: 2, lg: 4 }}>
        <Skeleton w='full' aspectRatio='1 / 1' rounded={12} />
      </Card.Header>

      {/* Body */}
      <Card.Body pb={3} px={{ base: 2, lg: 4 }} pt={{ base: 3, lg: 4 }}>
        {/* Price */}
        <Skeleton h={{ base: '20px', lg: '26px' }} w='88px' rounded={8} />

        {/* Title (2 lines fixed height) */}
        <Box my={{ base: 2, lg: 3 }}>
          <Skeleton h={{ base: '14px', lg: '26px' }}  w='90%' rounded={6} />
        </Box>
      </Card.Body>

      {/* Footer (Add button) */}
      <Card.Footer
        px={{ base: 2, lg: 4 }}
        pb={{ base: 2, lg: 4 }}
        flexDir='column'
        alignItems='stretch'
      >
        <Skeleton h='40px' w='full' rounded={12} />
      </Card.Footer>
    </Card.Root>
  )
}
